import gql from 'graphql-tag';

export const REQUEST_PLANNING_CYCLE_CLONE = gql`
  mutation RequestPlanningCycleClone($planningCycleId: Int!) {
    requestPlanningCycleClone(input: { planningCycleId: $planningCycleId }) {
      messageId
    }
  }
`;
